import React from 'react'
import { Container } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import BOTRequestsContainer from '../components/BackOfficeTechnology/BOTRequestsContainer';

class BOTRequests extends React.Component {

  render() {
    return (<Container fluid>
      <BOTRequestsContainer {...this.props} />
    </Container>
    );
  }
}

export default BOTRequests;